import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "../i18n";
import { FLAVORS, PRICE } from "../data/products";

const StoreContext = createContext(null);

export const StoreProvider = ({ children }) => {
  const [lang, setLang] = useState("nl");
  const [flavor, setFlavor] = useState("tropical");
  const [cart, setCart] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);

  const t = translations[lang];

  useEffect(() => {
    const theme = FLAVORS[flavor].theme;
    const root = document.documentElement;
    root.style.setProperty("--accent", theme.accent);
    root.style.setProperty("--accent-rgb", theme.accentRgb);
    root.style.setProperty("--accent-contrast", theme.contrast);
  }, [flavor]);

  const switchFlavor = (f) => {
    if (f === flavor || !FLAVORS[f]) return;
    setFlavor(f);
  };

  const addToCart = (f, qty = 1) => {
    setCart((prev) => {
      const existing = prev.find((i) => i.flavor === f);
      if (existing) {
        return prev.map((i) => (i.flavor === f ? { ...i, qty: Math.min(99, i.qty + qty) } : i));
      }
      return [...prev, { flavor: f, qty }];
    });
    setCartOpen(true);
  };

  const updateQty = (f, delta) => {
    setCart((prev) =>
      prev
        .map((i) => (i.flavor === f ? { ...i, qty: i.qty + delta } : i))
        .filter((i) => i.qty > 0)
    );
  };

  const removeFromCart = (f) => setCart((prev) => prev.filter((i) => i.flavor !== f));
  const clearCart = () => setCart([]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      t,
      flavor,
      switchFlavor,
      cart,
      addToCart,
      updateQty,
      removeFromCart,
      clearCart,
      cartOpen,
      setCartOpen,
      cartCount: cart.reduce((s, i) => s + i.qty, 0),
      cartTotal: cart.reduce((s, i) => s + i.qty * PRICE, 0),
    }),
    [lang, t, flavor, cart, cartOpen]
  );

  return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>;
};

export const useStore = () => useContext(StoreContext);
